import React, { Component } from 'react';
import ExpandedForm from './ExpandedForm';
import { getSysFieldid } from '@platform/api';
import Table from '@platform/table-core';
import ResizeObserver from 'rc-resize-observer';
import { getScrollBarSize } from '../../../utils';

const scrollBarSize = getScrollBarSize();

class FormList extends Component {
    constructor(props) {
        super(props);
        this.state = { hasScrollBar: false };
    }

    render() {
        let { store, moduleId, configs, formLayout, formItems, width, flex, stores, pageScope, formId } = this.props,
            { hasScrollBar } = this.state;

        let config = configs[moduleId],
            { height, onRowClick } = config || {},
            rowsHeight = store.getRowsHeight(),
            activeTab = store.getActiveTab() || moduleId;

        return <div fieldid={getSysFieldid(`${configs[moduleId]?.fieldid || moduleId}_list-area`)} className="flex-container form-list-wrapper">
            <div fieldid={getSysFieldid('list-item')} className="flex-container">
                <Table.BaseTable
                    columns={[{
                        key: 'form',
                        width: Number(width) - (hasScrollBar ? scrollBarSize : 0) - 2, // 减去border宽度
                        render: row => {
                            return <ResizeObserver
                                onResize={({ height }) => {
                                    rowsHeight[`${row.key}-form-list`] = height;
                                    store.setRowsHeight(rowsHeight);
                                }}
                            >
                                <ExpandedForm
                                    layout={formLayout}
                                    items={formItems}
                                    values={row.values}
                                    store={store}
                                    rowKey={row.key}
                                    formStore={stores[formId]}
                                ></ExpandedForm>
                            </ResizeObserver>;
                        },
                    }]}
                    rows={store.getVisibleRows()}
                    hideHeader
                    rowProps={row => {
                        return { onClick: e => onRowClick?.({ ...pageScope.props, ...pageScope.output }, activeTab, row, stores[activeTab].getRowData(row.key).dataIndex, e) };
                    }}
                    rowHeight={Object.values(rowsHeight).length ? Object.values(rowsHeight)[1] : 150}
                    rowsHeight={rowsHeight}
                    rowKey={row => `${row.key}-form-list`}
                    locale={store.getLocale()}
                    flex={flex}
                    bodyStyle={{
                        minHeight: 60, // 2行
                        maxHeight: flex ? 'none' : (height || 28 * 10),
                        height: height || 'auto',
                    }}
                    _onScrollBarStatusChange={status => {
                        this.setState({ hasScrollBar: status });
                    }}
                />
            </div>
        </div>;
    }
}

export default FormList;